import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class HomepageBlocksApi extends Api {
  constructor() {
    super('website/homepage_blocks/');
  }

  // GET all with filters
  list = (params = {}) => {
    return this.buildQuery('get', { params });
  };

  // GET one by ID
  show = (id) => {
    return this.buildQuery('get', {}, id);
  };

  // CREATE homepage block
  create = (data) => {
    const formData = new FormData();

    formData.append('homepage_block[title_it]', data.title_it || '');
    formData.append('homepage_block[title_en]', data.title_en || '');
    formData.append('homepage_block[title_fr]', data.title_fr || '');

    formData.append('homepage_block[description_it]', data.description_it || '');
    formData.append('homepage_block[description_en]', data.description_en || '');
    formData.append('homepage_block[description_fr]', data.description_fr || '');

    formData.append('homepage_block[link_it]', data.link_it || '');
    formData.append('homepage_block[link_en]', data.link_en || '');
    formData.append('homepage_block[link_fr]', data.link_fr || '');

    if (data.shopping_center_id) formData.append('homepage_block[shopping_center_id]', data.shopping_center_id);

    if (data.show_link === true) {
      formData.append('homepage_block[show_link]', true);
    } else {
      formData.append('homepage_block[show_link]', false);
    }

    if (data.file) {
      formData.append('homepage_block[file]', data.file);
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_blocks`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPDATE homepage block
  update = (id, data) => {
    const formData = new FormData();

    formData.append('homepage_block[title_it]', data.title_it || '');
    formData.append('homepage_block[title_en]', data.title_en || '');
    formData.append('homepage_block[title_fr]', data.title_fr || '');

    formData.append('homepage_block[description_it]', data.description_it || '');
    formData.append('homepage_block[description_en]', data.description_en || '');
    formData.append('homepage_block[description_fr]', data.description_fr || '');

    formData.append('homepage_block[link_it]', data.link_it || '');
    formData.append('homepage_block[link_en]', data.link_en || '');
    formData.append('homepage_block[link_fr]', data.link_fr || '');

    if (data.shopping_center_id) {
      formData.append('homepage_block[shopping_center_id]', data.shopping_center_id);
    }

    if (data.show_link === true) {
      formData.append('homepage_block[show_link]', true);
    } else {
      formData.append('homepage_block[show_link]', false);
    }

    if (data.file) {
      formData.append('homepage_block[file]', data.file);
    }

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_blocks/${id}`,
      method: 'PUT',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // DELETE homepage block
  destroy = (id) => {
    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_blocks/${id}`,
      method: 'DELETE',
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // UPLOAD file
  upload = (file) => {
    const formData = new FormData();
    formData.append('file', file);

    return axios({
      url: `${process.env.REACT_APP_API_URL}/website/homepage_blocks/uploads`,
      method: 'POST',
      data: formData,
      headers: {
        'auth-token': AuthService.getToken(),
      },
    });
  };

  // GET filters (shopping_centers, etc)
  getFilters = () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/filters`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default new HomepageBlocksApi();

